<template>
 <div  v-on:click='$emit("clicked", event.id)' class="seasoncast-card-item">
      <div class="row scoreCardInner">

        <div class="col-7 scoreCardTeams"> 

          <div class="d-flex flex-row">
           <div v-if="(!event.teams) || event.teams.length == 0 || event.type=='general'">
               <div class="scoreCardTeamsName">
                 <span class="" v-text="event.eventName"></span><br /> <small class="" >{{ $t('general-event') }}</small>
                 </div>
           </div>
            <div v-else>
              
              <div v-for="team in event.teams" v-bind:key="team.name">
                    <div class="scoreCardTeamsName">
                <span class="scoreColor" v-bind:style="'width:10px; height:10px; margin:5px; background-color:'+team.color"  >
                  &nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span style="cursor:pointers" @clicked="$router.push('/team/'+team.id)" v-text="team.name"></span>
              </div>
              </div>
          
              
              </div>
            </div>



          </div>
        
        <div class="col-2 scoreCardTeams">
<div v-if="totalScore != 0">
          <div class="scoreText"  v-for="team in event.teams" v-bind:key="team.name" v-text="team.score"
            >
        
      
        </div>
 </div>
        </div>
        <div class="info col-3">
        
          <span>{{ status}}<br />
          
         {{ new Date(event.timeStart*1000).toLocaleDateString()}}</span>
          <br />
        </div>
      </div>
      </div>       
</template>

<script>
//lose score color:#8a8a8a;

export default {
  name: 'Event',
  props: ['event', 'channel_id'],
  computed: {
    totalScore: function(){
      var total = 0
      if ( this.event.teams){
      for (let index = 0; index < this.event.teams.length; index++) {
        const element = this.event.teams[index];
        total += element.score
      }

    
    }
      return total
    },

    status: function(){
      let currentTS = (new Date()).getTime() / 1000
      
      if (this.event.timeStart > currentTS){
        return this.$t('scheduled')
      }

     if (this.event.timeStart + 14400 > (currentTS )){
        return "In-Progress"
      }
    
    return this.$t('Final')

    }
  }
}
</script>

<style lang="scss" scoped>
 .info {
    border-left: 1px solid rgb(221, 221, 221);
    text-align: center;
    font-weight: 400;
    font-size: 0.8rem;

    display: flex;
    justify-content: center;
    /* align horizontal */
    align-items: center;
  }
.seasoncast-card-item{
    border-radius: 0.6rem;
}
  .scoreCard {
    background-color: white;

    border-radius: 0.3rem;
  }

  .scoreText {
    width: 100%;
    text-align: right;

  }

  .scoreCardTeams {
    font-size: 1.3rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

  }

  .scoreCardTeamsName {

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }

  .broadcastNetwork {
    text-align: center;
    color: white;
    border-radius: 0.3rem 0.3rem 0 0;
    font-size: 0.9rem;
    padding: 0.3rem
  }

  .scoreCardInner {
   
  }


  .scoreIMG {
    width: auto;
    height: 3rem;
    border-radius: 0.3rem;
    display: flex;
    justify-content: center;
    /* align horizontal */
    align-items: center;
  }

  .scoreColor {
    font-size: 0.5rem;
    line-height: 100%;
    border-radius: 0.2rem;
    display: inline-block;
    vertical-align: middle;
  }

  .scoreCardHolder {
    padding: 1rem
  }

  .scoreCardTeamList {
    width: 70%;
  }

  .scoreCardListScore {
    width: 30%;
  }

  .card2 {
    border: 1px solid rgb(233, 233, 233);
    border-radius: 0.6rem;
  }
</style>
